/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getCopyGroup} from '../api'

 export const useQueryGetCopyGroup = createReactQueryHook('getCopyGroup', getCopyGroup)
